import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ed9098a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-chat-strip-label"
}
const _hoisted_2 = {
  key: 1,
  class: "nge-chat-strip-unread",
  title: "New messages"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-strip-spacer" }, null, -1 /* HOISTED */))
const _hoisted_4 = ["onClick", "title"]
const _hoisted_5 = { class: "nge-chat-messages-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-chat-fade" }, null, -1 /* HOISTED */))
const _hoisted_7 = { class: "nge-chat-messages-inner" }
const _hoisted_8 = {
  key: 0,
  class: "nge-chat-time-sep"
}
const _hoisted_9 = ["onClick", "onKeydown"]
const _hoisted_10 = { class: "nge-chat-msg-time" }
const _hoisted_11 = { class: "nge-chat-announce-text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-chat-announce-cta" }, "Open →", -1 /* HOISTED */))
const _hoisted_13 = {
  key: 3,
  class: "nge-chat-msg"
}
const _hoisted_14 = { class: "nge-chat-msg-time" }
const _hoisted_15 = {
  key: 0,
  class: "nge-chat-msg-trophy"
}
const _hoisted_16 = ["onClick", "title"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["onClick", "onKeydown", "title"]
const _hoisted_19 = {
  key: 3,
  class: "nge-chat-seg-chip"
}
const _hoisted_20 = ["onClick", "onKeydown", "title"]
const _hoisted_21 = ["title"]
const _hoisted_22 = ["onClick", "title"]
const _hoisted_23 = {
  key: 4,
  class: "nge-chat-msg-text"
}
const _hoisted_24 = {
  key: 0,
  class: "nge-chat-empty"
}
const _hoisted_25 = {
  key: 1,
  class: "nge-chat-empty"
}
const _hoisted_26 = {
  key: 0,
  class: "nge-chat-segwarn"
}
const _hoisted_27 = { class: "nge-chat-segwarn-text" }
const _hoisted_28 = { class: "nge-chat-segwarn-actions" }
const _hoisted_29 = { class: "nge-chat-input-wrap" }
const _hoisted_30 = ["placeholder", "onKeydown", "disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      ref: "panelEl",
      class: _normalizeClass(["nge-chat-float", { 'nge-chat-float--collapsed': $setup.collapsed, 'nge-chat-float--dragging': $setup.isDragging }]),
      style: _normalizeStyle({
        ...($setup.collapsed ? {} : { width: $setup.panelWidth + 'px', height: $setup.panelHeight + 'px' }),
        ...$setup.positionStyle
      })
    }, [
      _createCommentVNode(" Resize handles — edges and corner "),
      (!$setup.collapsed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nge-chat-resize nge-chat-resize--corner",
            onMousedown: _cache[0] || (_cache[0] = $event => ($setup.startResize($event, 'corner')))
          }, null, 32 /* HYDRATE_EVENTS */))
        : _createCommentVNode("v-if", true),
      (!$setup.collapsed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "nge-chat-resize nge-chat-resize--top",
            onMousedown: _cache[1] || (_cache[1] = $event => ($setup.startResize($event, 'top')))
          }, null, 32 /* HYDRATE_EVENTS */))
        : _createCommentVNode("v-if", true),
      (!$setup.collapsed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "nge-chat-resize nge-chat-resize--right",
            onMousedown: _cache[2] || (_cache[2] = $event => ($setup.startResize($event, 'right')))
          }, null, 32 /* HYDRATE_EVENTS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Tiny drag/control strip "),
      _createElementVNode("div", {
        class: "nge-chat-strip",
        onMousedown: $setup.startDrag,
        onDblclick: $setup.toggleCollapse
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["nge-chat-strip-dot", { 'nge-chat-strip-dot--on': $setup.connected }])
        }, null, 2 /* CLASS */),
        ($setup.collapsed)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Chat"))
          : _createCommentVNode("v-if", true),
        ($setup.collapsed && $setup.unreadMessages)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : _createCommentVNode("v-if", true),
        _hoisted_3,
        _createElementVNode("button", {
          class: "nge-chat-strip-btn nge-chat-collapse-btn",
          onClick: _withModifiers($setup.toggleCollapse, ["stop"]),
          title: $setup.collapsed ? 'Expand chat' : 'Collapse chat'
        }, _toDisplayString($setup.collapsed ? '▲' : '▼'), 9 /* TEXT, PROPS */, _hoisted_4),
        _createElementVNode("button", {
          class: "nge-chat-strip-btn nge-chat-close-btn",
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($setup.emit('hide')), ["stop"])),
          title: "Close chat"
        }, "×")
      ], 32 /* HYDRATE_EVENTS */),
      _createCommentVNode(" Body (hidden when collapsed) "),
      (!$setup.collapsed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createCommentVNode(" Message area with top fade "),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", {
                class: "nge-chat-messages",
                ref: "scrollContainer",
                onScroll: $setup.handleScroll
              }, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chatMessages, (msg, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (msg.type === 'time')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", null, _toDisplayString(msg.time), 1 /* TEXT */)
                          ]))
                        : (msg.type === 'join' || msg.type === 'leave' || msg.type === 'disconnected')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["nge-chat-sys", { 'nge-chat-sys--warn': msg.type === 'disconnected' }])
                            }, _toDisplayString(msg.type === 'join' ? '→' : msg.type === 'leave' ? '←' : '⚠') + " " + _toDisplayString(msg.parts[0]?.text || ''), 3 /* TEXT, CLASS */))
                          : (msg.type === 'message' && msg.notificationId)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createCommentVNode(" Announcement: carries a notification id, so the whole\n                     message opens that notification instead of telling the\n                     reader to go and look for it. "),
                                _createElementVNode("div", {
                                  class: "nge-chat-msg nge-chat-announce",
                                  role: "button",
                                  tabindex: "0",
                                  onClick: $event => ($setup.openAnnouncement(msg.notificationId)),
                                  onKeydown: _withKeys($event => ($setup.openAnnouncement(msg.notificationId)), ["enter"]),
                                  title: "Open this notification"
                                }, [
                                  _createElementVNode("span", _hoisted_10, _toDisplayString($setup.msgTime(msg.dateTime)), 1 /* TEXT */),
                                  _createElementVNode("span", _hoisted_11, _toDisplayString(msg.parts.filter(p => p.type !== 'sender').map(p => p.text).join('')), 1 /* TEXT */),
                                  _hoisted_12
                                ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9)
                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            : (msg.type === 'message')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString($setup.msgTime(msg.dateTime)), 1 /* TEXT */),
                                  ($setup.trophyMap[msg.name])
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.trophyMap[msg.name]), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("button", {
                                    class: "nge-chat-msg-name nge-chat-msg-name--clickable",
                                    style: _normalizeStyle({ color: $setup.rankColor(msg.rank) }),
                                    onClick: $event => ($setup.openUserProfile(msg.name)),
                                    title: 'View ' + msg.name + '\'s profile'
                                  }, _toDisplayString($setup.shortName(msg.name)), 13 /* TEXT, STYLE, PROPS */, _hoisted_16),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.parts, (part, pi) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: pi }, [
                                      (part.type === 'sender')
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64 /* STABLE_FRAGMENT */))
                                        : (part.type === 'link')
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              href: part.text,
                                              target: "_blank",
                                              rel: "noopener",
                                              class: "nge-chat-link"
                                            }, _toDisplayString(part.text), 9 /* TEXT, PROPS */, _hoisted_17))
                                          : (part.type === 'mention')
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 2,
                                                class: _normalizeClass(["nge-chat-mention", { 'nge-chat-mention--me': $setup.isSelfMention(part.text) }]),
                                                role: "button",
                                                tabindex: "0",
                                                onClick: $event => ($setup.openUserProfile(part.text.slice(1))),
                                                onKeydown: _withKeys($event => ($setup.openUserProfile(part.text.slice(1))), ["enter"]),
                                                title: 'Open ' + part.text.slice(1) + '’s profile'
                                              }, _toDisplayString(part.text), 43 /* TEXT, CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_18))
                                            : (part.type === 'segment')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                  _createElementVNode("span", {
                                                    class: "nge-chat-seg-link",
                                                    role: "button",
                                                    tabindex: "0",
                                                    onClick: $event => ($setup.onSegClick(part.text, msg.dataset)),
                                                    onKeydown: _withKeys($event => ($setup.onSegClick(part.text, msg.dataset)), ["enter"]),
                                                    title: 'Jump to segment ' + part.text.slice(1) + (msg.dataset ? ' in ' + msg.dataset : '')
                                                  }, _toDisplayString(part.text), 41 /* TEXT, PROPS, HYDRATE_EVENTS */, _hoisted_20),
                                                  _createElementVNode("span", {
                                                    class: "nge-chat-seg-ds",
                                                    title: msg.dataset || 'Sent before the dataset was recorded'
                                                  }, _toDisplayString($setup.datasetLabel(msg.dataset)), 9 /* TEXT, PROPS */, _hoisted_21),
                                                  _createElementVNode("button", {
                                                    class: "nge-chat-seg-copy",
                                                    onClick: $event => ($setup.copySegId(part.text, $event)),
                                                    title: 'Copy ' + part.text.slice(1)
                                                  }, _toDisplayString($setup.copiedSegId === part.text.slice(1) ? '✓' : '⧉'), 9 /* TEXT, PROPS */, _hoisted_22)
                                                ]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(part.text), 1 /* TEXT */))
                                    ], 64 /* STABLE_FRAGMENT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  (!$setup.isLoggedIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Log in to chat "))
                    : ($setup.chatMessages.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Say hello! "))
                      : _createCommentVNode("v-if", true)
                ])
              ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)
            ]),
            _createCommentVNode(" New messages banner "),
            _createVNode(_Transition, { name: "nge-chat-banner" }, {
              default: _withCtx(() => [
                ($setup.isScrolledUp && $setup.unreadMessages)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "nge-chat-new-banner",
                      onClick: $setup.scrollToBottom
                    }, " ↓ new "))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode(" Cross-dataset jump guard: a root ID from another segmentation would\n             land on a different cell (or nothing) without warning. "),
            ($setup.pendingSegJump)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createTextVNode(" This ID is from "),
                    _createElementVNode("strong", null, _toDisplayString($setup.pendingSegJump.from || 'an unknown dataset'), 1 /* TEXT */),
                    _createTextVNode(", but you're viewing "),
                    _createElementVNode("strong", null, _toDisplayString($setup.pendingSegJump.to), 1 /* TEXT */),
                    _createTextVNode(". It may not exist here. ")
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      class: "nge-chat-segwarn-go",
                      onClick: $setup.confirmSegJump
                    }, "Jump anyway"),
                    _createElementVNode("button", {
                      class: "nge-chat-segwarn-no",
                      onClick: _cache[4] || (_cache[4] = $event => ($setup.pendingSegJump = null))
                    }, "Cancel")
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Input "),
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                ref: "inputEl",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.messageInput) = $event)),
                class: "nge-chat-input",
                placeholder: $setup.isLoggedIn ? 'Message...' : 'Log in to chat',
                onKeydown: [
                  _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                  _withKeys(_withModifiers($setup.send, ["exact","prevent"]), ["enter"])
                ],
                onKeyup: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                onKeypress: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                spellcheck: "true",
                autocomplete: "off",
                disabled: !$setup.isLoggedIn || !$setup.connected
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_30), [
                [_vModelText, $setup.messageInput]
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ], 6 /* CLASS, STYLE */)
  ]))
}